var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"multiple":_vm.multiple,"options":_vm.options,"label":_vm.label,"value":_vm.value,"placeholder":_vm.placeholder,"name":_vm.name,"id":_vm.id},on:{"input":_vm.onInput}},[_c('template',{slot:"no-options"},[_vm._v(_vm._s(_vm.noOptionsText))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }